(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog-featured"] && !window.DesignMode) return;
  try {
    
	(function() {
		var desktop_images = $('.blog-featured-img-url-list .js-cl-desktop-images span');
		var tablet_images = $('.blog-featured-img-url-list .js-cl-tablet-images span')
		var mobile_images = $('.blog-featured-img-url-list .js-cl-mobile-images span');

		var to_be_set_img = $('.blog__frames .blog__frames-item');

		window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
		$(window).resize(function() {
			window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
		})
	})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-inspiration-post-banner"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.blog__inspiration_post-banner-img_wrapper');
  var post_id = $('.blog__inspiration_post').attr('alt');
  var desktop_images = $('.blog__inspiration_post-img-list[alt="'+ post_id +'"] .js-cl-desktop-images span');
  var tablet_images = $('.blog__inspiration_post-img-list[alt="'+ post_id +'"] .js-cl-tablet-images span');
  var mobile_images = $('.blog__inspiration_post-img-list[alt="'+ post_id +'"] .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

  $(window).resize(function() {
	window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
  })
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-inspiration"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.blog__inspiration-item-img_wrapper');

  var desktop_images = $('.blog__inspiration-item-img_wrapper .js-cl-desktop-images span');
  var tablet_images = $('.blog__inspiration-item-img_wrapper .js-cl-tablet-images span');
  var mobile_images = $('.blog__inspiration-item-img_wrapper .js-cl-mobile-images span');
  
  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-men-inspiration"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.blog__inspiration-item-img_wrapper');

  var desktop_images = $('.blog__inspiration-item-img_wrapper .js-cl-desktop-images span');
  var tablet_images = $('.blog__inspiration-item-img_wrapper .js-cl-tablet-images span');
  var mobile_images = $('.blog__inspiration-item-img_wrapper .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

  $(window).resize(function() {
	window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-video"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.blog_videos__image_wrapper a');

  var desktop_images = $('.blog_viedeos__wrapper .js-cl-desktop-images span');
  var tablet_images = $('.blog_viedeos__wrapper .js-cl-tablet-images span');
  var mobile_images = $('.blog_viedeos__wrapper .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-walled-garden-post"]) return;
  try {
    
(function() {
	var to_be_set_img = $('.blog__walled_garden_post-banner_img_wrapper');

	var desktop_images = $('.blog_walled_garden_post[alt="'+ window.location.pathname +'"]' +' .js-cl-desktop-images span');
	var tablet_images = $('.blog_walled_garden_post[alt="'+ window.location.pathname +'"]' +' .js-cl-tablet-images span');
	var mobile_images = $('.blog_walled_garden_post[alt="'+ window.location.pathname +'"]' +' .js-cl-mobile-images span');

	window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

	$(window).resize(function() {
		window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
	})
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-walled-garden"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.blog__walled_garden-item-img_wrapper');

  var desktop_images = $('.blog__walled_garden-item-img_wrapper .js-cl-desktop-images span');
  var tablet_images = $('.blog__walled_garden-item-img_wrapper .js-cl-tablet-images span');
  var mobile_images = $('.blog__walled_garden-item-img_wrapper .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

  $(window).resize(function() {
	window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
	$('.shopcart-calc, .table__row_column').on('click','.shopcart-down',function(e){
		var value = $(e.target).siblings('input').val();
		if(value > 1) {
			$(e.target).siblings('input').val(parseInt(value) - 1);
		}
		return;
    });

    $('.shopcart-calc, .table__row_column').on('click','.shopcart-up',function(e){
        var value = $(e.target).siblings('input').val();
        $(e.target).siblings('input').val(parseInt(value) + 1);
        return;
    });

    // 屏幕变化，禁掉不同的input，防止表单提交
    $(window).resize(function(){
        if(document.body.clientWidth < 900 && $('.shopcart-calc input').attr('disabled')) {
            $('.shopcart-calc input').attr('disabled','disabled');
            return;
        }
        $('.shopcart-calc input').removeAttr('disabled');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner-men"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.collections__banner');

  var desktop_images = $('.collection-banner-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-banner-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-banner-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })

  $('.collections__banner[alt="'+ window.location.pathname +'"]').show();
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.collections__banner');

  var desktop_images = $('.collection-banner-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-banner-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-banner-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })

  $('.collections__banner[alt="'+ window.location.pathname +'"]').show();
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-women"] && !window.DesignMode) return;
  try {
    
(function() {
  var swiper_item = $('.swiper-wrapper .a-block');

  var desktop_images = $('.collection-list-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-list-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-list-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)
  })
})();

var mySwiper = new Swiper ('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    // 分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !window.DesignMode) return;
  try {
    
(function() {
  var swiper_item = $('.swiper-wrapper .a-block');

  var desktop_images = $('.collection-list-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-list-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-list-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)
  })
})();

var mySwiper = new Swiper ('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    // 分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-men-showcase"] && !window.DesignMode) return;
  try {
    
(function() {
  var to_be_set_img = $('.collection-showcase .img-wrapper');

  var desktop_images = $('.collection-showcase-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-showcase-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-showcase-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-men-top-showcase"] && !window.DesignMode) return;
  try {
    
(function() {
  var to_be_set_img = $('.collection-showcase .img-wrapper-top');

  var desktop_images = $('.collection-showcase-img-url-list1 .js-cl-desktop-images span');
  var tablet_images = $('.collection-showcase-img-url-list1 .js-cl-tablet-images span')
  var mobile_images = $('.collection-showcase-img-url-list1 .js-cl-mobile-images span');

  window.responsive_bgimg1(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg1(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
(function() {
	var to_be_set_img = $('.collection-product-variant-img-wrapper');

	var desktop_images = $('.collection-product-variant-img-wrapper .js-cl-desktop-images span');
	var tablet_images = $('.collection-product-variant-img-wrapper .js-cl-tablet-images span');
	var mobile_images = $('.collection-product-variant-img-wrapper .js-cl-mobile-images span');

	window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);

	$(window).resize(function() {
		window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images);
	})
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-showcase"] && !window.DesignMode) return;
  try {
    
(function() {
  var to_be_set_img = $('.collection-showcase .img-wrapper');

  var desktop_images = $('.collection-showcase-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-showcase-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-showcase-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-women-showcase"] && !window.DesignMode) return;
  try {
    
(function() {
  var to_be_set_img = $('.collection-showcase .img-wrapper');

  var desktop_images_wbottom = $('.collection-showcase-img-url-list .js-cl-desktop-images span');
  var tablet_images_wbottom = $('.collection-showcase-img-url-list .js-cl-tablet-images span')
  var mobile_images_wbottom = $('.collection-showcase-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images_wbottom, tablet_images_wbottom, mobile_images_wbottom)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images_wbottom, tablet_images_wbottom, mobile_images_wbottom)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-women-top-showcase"] && !window.DesignMode) return;
  try {
    
(function() {
  var to_be_set_img = $('.collection-showcase .img-wrapper-top');

  var desktop_images = $('.collection-showcase-img-url-list1 .js-cl-desktop-images span');
  var tablet_images = $('.collection-showcase-img-url-list1 .js-cl-tablet-images span')
  var mobile_images = $('.collection-showcase-img-url-list1 .js-cl-mobile-images span');

  window.responsive_bgimg1(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg1(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.featured-collection .image-wrapper');

  var desktop_images = $('.featured-collection-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.featured-collection-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.featured-collection-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-men-collection"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.featured-collection .image-wrapper');

  var desktop_images = $('.featured-collection-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.featured-collection-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.featured-collection-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-women-collection"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.featured-collection .image-wrapper');

  var desktop_images = $('.featured-collection-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.featured-collection-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.featured-collection-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $('.header__left-search,.search__title .close').click(function(){
    $('.search-form').slideToggle();
    $('body').toggleClass('ban-scroll');
  });
  $('.btn-bars').click(function(){
    $('.mobile-nav,.btn-close').show();
    $('.btn-bars,#MainContent,#shopify-section-footer').hide();
    $('#shopify-section-header').css({
      position: 'fixed',
      width: '100%'
    });
  });
  $('.btn-close').click(function(e) {
    $('.mobile-nav,.btn-close').hide();
    $('.btn-bars,#MainContent,#shopify-section-footer').show();
    $('#shopify-section-header').css({
      position: 'unset'
    });
  });
  $('.mobile-nav-item').click(function(e){
    $(this).find('.site-nav__submenu').slideToggle();
  });
  $('.cn-js-selector').click(function(e) {
    $('.mobile-cn-qrcode-wrapper').slideToggle();
  });
  $('.nav__warp').on('click','.site-nav--has-submenu',function(e){
    $(this).toggleClass('site-nav--active','');
  });

  var sub_menu_class_selector = '.site-nav__submenu';
  $(document).click(function(e) {
      var target = e.target;
      var nav = $('.site-nav')[0];
      // console.log('nav.contains(target) ? ', nav.contains(target));
      if (target === nav || nav.contains(target)) {
          return false;
      }
      $('.site-nav--has-submenu').removeClass('active');
  });
  $('.site-nav').on('click', '.site-nav--has-submenu', function(e) {
    var _this = this;
    if($(_this).siblings().hasClass('active')){
      $(_this).siblings().removeClass('active');
      setTimeout(function() {
        $(_this).toggleClass('active','')
      }, 200);
      return;
    }
    $(_this).toggleClass('active','').siblings().removeClass('active');
  });
  $('.site-nav__submenu').on('click', function(e) {
    e.stopPropagation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection-men-showcase"] && !window.DesignMode) return;
  try {
    
(function() {
  var to_be_set_img = $('.collection-showcase .img-wrapper');

  var desktop_images = $('.collection-showcase-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-showcase-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-showcase-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-collection"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.featured-collection .image-wrapper');

  var desktop_images = $('.featured-collection-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.featured-collection-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.featured-collection-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-men-collection"]) return;
  try {
    
(function() {
  var to_be_set_img = $('.featured-collection .image-wrapper');

  var desktop_images = $('.featured-collection-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.featured-collection-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.featured-collection-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_img, desktop_images, tablet_images, mobile_images)
  })
})()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-men-collection-list"] && !window.DesignMode) return;
  try {
    
(function() {
  var swiper_item = $('.swiper-wrapper .a-block');

  var desktop_images = $('.collection-list-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-list-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-list-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)
  })
})();

var mySwiper = new Swiper ('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    // 分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-women-collection-list"] && !window.DesignMode) return;
  try {
    
(function() {
  var swiper_item = $('.swiper-wrapper .a-block');

  var desktop_images = $('.collection-list-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-list-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-list-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)
  })
})();

var mySwiper = new Swiper ('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    // 分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-categories"]) return;
  try {
    
/*
	$('.list-categories-section .desc_content').css('display', 'none');
	if (window.lowndes_category.length > 6) {
		$(".list-categories-section .holder").jPages({
						containerID : "list-categories-wrapper",
						perPage     : 3,
						animation   : "fadeInDown",
						delay       : 50,
						direction   : "auto",
						previous: 'i.arrowPrev', 
						next: 'i.arrowNext',
						minHeight : false
				}); 
	} else {
		$('.list-categories-pagination').css('display', 'none');
	}
*/

(function() {
  var to_be_set_dom = $('.list-categories-section .img-wrapper');

  var desktop_images = $('.list-categories-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.list-categories-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.list-categories-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  })
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collection"]) return;
  try {
    
(function() {
  var to_be_set_dom = $('.list-collections-section .img-wrapper');

  var desktop_images = $('.list-collection-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.list-collection-img-url-list .js-cl-tablet-images span');
  var mobile_images = $('.list-collection-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  $(window).resize(function() {
	window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  })
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-men-categories"]) return;
  try {
    
/*
	$('.list-categories-section .desc_content').css('display', 'none');
	if (window.lowndes_category.length > 6) {
		$(".list-categories-section .holder").jPages({
						containerID : "list-categories-wrapper",
						perPage     : 3,
						animation   : "fadeInDown",
						delay       : 50,
						direction   : "auto",
						previous: 'i.arrowPrev', 
						next: 'i.arrowNext',
						minHeight : false
				}); 
	} else {
		$('.list-categories-pagination').css('display', 'none');
	}
*/

(function() {
  var to_be_set_dom = $('.list-categories-section .img-wrapper');

  var desktop_images = $('.list-categories-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.list-categories-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.list-categories-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  })
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-men-collection"]) return;
  try {
    
/*
	$('.list-categories-section .desc_content').css('display', 'none');
	if (window.lowndes_category.length > 6) {
		$(".list-categories-section .holder").jPages({
						containerID : "list-categories-wrapper",
						perPage     : 3,
						animation   : "fadeInDown",
						delay       : 50,
						direction   : "auto",
						previous: 'i.arrowPrev', 
						next: 'i.arrowNext',
						minHeight : false
				}); 
	} else {
		$('.list-categories-pagination').css('display', 'none');
	}
*/

(function() {
  var to_be_set_dom = $('.list-categories-section .img-wrapper');

  var desktop_images = $('.list-categories-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.list-categories-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.list-categories-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  $(window).resize(function() {
    window.responsive_bgimg(to_be_set_dom, desktop_images, tablet_images, mobile_images)
  })
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["men-collection-list"] && !window.DesignMode) return;
  try {
    
(function() {
  var swiper_item = $('.swiper-wrapper .a-block');

  var desktop_images = $('.collection-list-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-list-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-list-img-url-list .js-cl-mobile-images span');

  window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)
  })
})();

var mySwiper = new Swiper ('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    // 分页器
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-img"]) return;
  try {
    
$(document).ready(function() {
	var collectionID = $('.product-collection-img-wrapper').attr('alt');
	var to_be_set_bgimg = $('.product-collection-img-wrapper');

	var desktop_images = $('.product-collection-img[alt="'+ collectionID +'"]' +' .js-cl-desktop-images span');
	var tablet_images = $('.product-collection-img[alt="'+ collectionID +'"]' +' .js-cl-tablet-images span');
	var mobile_images = $('.product-collection-img[alt="'+ collectionID +'"]' +' .js-cl-mobile-images span');
	window.responsive_bgimg(to_be_set_bgimg, desktop_images, tablet_images, mobile_images);

	$(window).resize(function() {
		window.responsive_bgimg(to_be_set_bgimg, desktop_images, tablet_images, mobile_images);
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-post"]) return;
  try {
    
$(document).ready(function() {
	var collectionIDs = $('.product-collection-post-wrapper .current-collection').map((i,a)=>a.getAttribute('alt'));
	var collectionID = collectionIDs.filter((i, id) => $('.product-collection-post[alt="'+ id +'"]').length > 0)[0]
	var to_be_set_bgimg = $('.product-collection-post-wrapper');
	var to_be_set_img = $('.product-collection-post-target[alt="'+ collectionID +'"]');

	var desktop_images = $('.product-collection-post[alt="'+ collectionID +'"]' +' .js-cl-desktop-images span');
	var tablet_images = $('.product-collection-post[alt="'+ collectionID +'"]' +' .js-cl-tablet-images span');
	var mobile_images = $('.product-collection-post[alt="'+ collectionID +'"]' +' .js-cl-mobile-images span');
	window.responsive_img(to_be_set_img, desktop_images, tablet_images, mobile_images);
	window.responsive_bgimg(to_be_set_bgimg, desktop_images, tablet_images, mobile_images);
	var article = $($('.product-collection-article[alt="'+ collectionID +'"]').detach());
	article.show().appendTo('.product-collection-article-wrapper');

	$(window).resize(function() {
		window.responsive_img(to_be_set_img, desktop_images, tablet_images, mobile_images);
		window.responsive_bgimg(to_be_set_bgimg, desktop_images, tablet_images, mobile_images);
	})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists-location"]) return;
  try {
    
(function() {
  var swiper_item = $('.swiper-wrapper .a-block');

  var desktop_images = $('.collection-list-img-url-list .js-cl-desktop-images span');
  var tablet_images = $('.collection-list-img-url-list .js-cl-tablet-images span')
  var mobile_images = $('.collection-list-img-url-list .js-cl-mobile-images span');

  /*window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)

  $(window).resize(function() {
    window.responsive_bgimg(swiper_item, desktop_images, tablet_images, mobile_images)
  });*/
})();


  } catch(e) { console.error(e); }
})();

})();
